<template>

</template>

<script>
    export default {
        data: function () {
            return {
                dropdownActive: false,
            }
        },
        methods: {
            onFocusOut: function () {
                setTimeout(() => {
                    this.dropdownActive = false;
                }, 300);
            },
            nameClick: function () {
                this.dropdownActive = !this.dropdownActive;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Dropdown.vue